import React from 'react';
import '../styles/Eventi.css'; 

const Eventi = () => {
  // Esempio di dati per gli eventi
  const prossimiEventi = [
    // { titolo: 'Torneo Community Minecraft', data: '25 Marzo 2026', ora: '21:00', tipo: 'Gaming' },
    // { titolo: 'Raduno Discord: Social Night', data: '02 Aprile 2026', ora: '21:30', tipo: 'Social' },
  ];

  const videoHighlight = [
    { id: 'xwM9UvCYDCM', titolo: 'Aurora SMP', creator: 'Simorz' },
    { id: 'uQ9ngp2JxeU', titolo: 'FormulaKraft', creator: 'Simorz' },
  ];

return (
    <div className="eventi-page">
      <div className="eventi-container">
        <header className="eventi-header">
          <h1 className="titolo-principale">Eventi Community</h1>
          <p className="descrizione-hero">Resta aggiornato sui tornei, i raduni e le attività della community Just4Fun.</p>
        </header>

        {/* Sezione Prossimi Eventi con Controllo Dati */}
        <section className="sezione-eventi">
          <h2 className="titolo-sezione">📅 Prossimi Appuntamenti</h2>
          
          {prossimiEventi.length > 0 ? (
            <div className="eventi-grid">
              {prossimiEventi.map((evento, index) => (
                <div key={index} className="eventi-card">
                  <div className="event-badge">{evento.tipo}</div>
                  <h3>{evento.titolo}</h3>
                  <p className="event-info"><strong>Data:</strong> {evento.data}</p>
                  <p className="event-info"><strong>Ora:</strong> {evento.ora}</p>
                  <a href="https://discord.just4fun.it" target="_blank" rel="noreferrer" className="btn-partecipa">Partecipa su Discord</a>
                </div>
              ))}
            </div>
          ) : (
            /* Messaggio quando non ci sono eventi */
            <div className="no-eventi-box">
              <div className="no-eventi-icon">🍃</div>
              <h3>Al momento non ci sono eventi in programma</h3>
              <p>Hai un'idea per dei nuovi contenuti? Parlane con noi su Discord!</p>
              <a href="https://discord.just4fun.it" target="_blank" rel="noreferrer" className="btn-custom-secondary">Proponi un evento</a>
            </div>
          )}
        </section>

        {/* Sezione Video Highlight (sempre visibile o gestita allo stesso modo) */}
        <section className="sezione-video">
          <h2 className="titolo-sezione">🎬 Highlight dai Creator</h2>
          <div className="video-grid">
            {videoHighlight.map((video, index) => (
              <div key={index} className="video-card">
                <div className="video-responsive">
                  <iframe 
                    src={`https://www.youtube.com/embed/${video.id}`} 
                    title={video.titolo}
                    frameBorder="0" 
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="video-info">
                  <h4>{video.titolo}</h4>
                  <span>{video.creator}</span>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Eventi;